import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-722d11ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x svg-icon-primary me-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-folder folder-icon" })
], -1))
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<span class=\"indicator-label\" data-v-722d11ab><span class=\"svg-icon svg-icon-1\" data-v-722d11ab><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-722d11ab><path d=\"M9.89557 13.4982L7.79487 11.2651C7.26967 10.7068 6.38251 10.7068 5.85731 11.2651C5.37559 11.7772 5.37559 12.5757 5.85731 13.0878L9.74989 17.2257C10.1448 17.6455 10.8118 17.6455 11.2066 17.2257L18.1427 9.85252C18.6244 9.34044 18.6244 8.54191 18.1427 8.02984C17.6175 7.47154 16.7303 7.47154 16.2051 8.02984L11.061 13.4982C10.7451 13.834 10.2115 13.834 9.89557 13.4982Z\" fill=\"currentColor\" data-v-722d11ab></path></svg></span></span><span class=\"indicator-progress\" data-v-722d11ab><span class=\"spinner-border spinner-border-sm align-middle\" data-v-722d11ab></span></span>", 2)
const _hoisted_5 = [
  _hoisted_3
]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<span class=\"indicator-label\" data-v-722d11ab><span class=\"svg-icon svg-icon-1\" data-v-722d11ab><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-722d11ab><rect opacity=\"0.5\" x=\"7.05025\" y=\"15.5356\" width=\"12\" height=\"2\" rx=\"1\" transform=\"rotate(-45 7.05025 15.5356)\" fill=\"currentColor\" data-v-722d11ab></rect><rect x=\"8.46447\" y=\"7.05029\" width=\"12\" height=\"2\" rx=\"1\" transform=\"rotate(45 8.46447 7.05029)\" fill=\"currentColor\" data-v-722d11ab></rect></svg></span></span><span class=\"indicator-progress\" data-v-722d11ab><span class=\"spinner-border spinner-border-sm align-middle\" data-v-722d11ab></span></span>", 2)
const _hoisted_8 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createElementVNode("input", {
      type: "text",
      name: "new_folder_name",
      ref: "new_folder_name",
      placeholder: "Enter the folder name",
      class: "form-control mw-250px me-3",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.folderName) = $event))
    }, null, 512), [
      [_vModelText, _ctx.folderName]
    ]),
    _createElementVNode("button", {
      class: "btn btn-icon btn-light-primary me-3",
      id: "kt_file_manager_add_folder",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
    }, _hoisted_5),
    _createElementVNode("button", {
      class: "btn btn-icon btn-light-danger",
      id: "kt_file_manager_cancel_folder",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
    }, _hoisted_8)
  ]))
}